export let InitialState = {
  breadcrumbs: {
    child: {
      title: '',
      route: {},
      copyValue: '',
    },
    grandChild: {
      title: '',
      route: {},
      copyValue: '',
    },
    parent: {
      title: '',
      route: {},
    },
  },
}
